import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { withRouter } from "react-router-dom";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import AppStoreBadge from "src/assets/images/store-badges/app_store_badge.png";
import MicrosoftStoreBadge from "src/assets/images/store-badges/microsoft_store_badge.png";
import GooglePlayBadge from "src/assets/images/store-badges/google_play_badge.png";
import { ErpType } from "src/network/User";
import styles from "./InspectionAppHint.module.css";

const erpConfig = {
    [ErpType.RIMO]: {
        titleKey: "screens.inspectionhint.title_r5",
        googlePlayUrl: "https://play.google.com/store/apps/details?id=ch.wwimmo.inspection.rimo",
        microsoftStoreUrl: "https://www.microsoft.com/store/apps/9n32f74bkdnl",
        appleAppStoreUrl: "https://apps.apple.com/ch/app/rimo-r5-abnahme/id1500396099"
    },
    [ErpType.IT2]: {
        titleKey: "screens.inspectionhint.title_it2",
        googlePlayUrl: "https://play.google.com/store/apps/details?id=ch.wwimmo.inspection.immotop",
        microsoftStoreUrl: "https://www.microsoft.com/store/apps/9pk4z59d5jdc",
        appleAppStoreUrl: "https://apps.apple.com/ch/app/immotop2-abnahme/id1496358864"
    },
    [ErpType.FAIRWALTER]: {
        titleKey: "screens.inspectionhint.title_fairwalter",
        googlePlayUrl: "https://play.google.com/store/apps/details?id=ch.wwimmo.inspection.fairwalter",
        microsoftStoreUrl: "https://www.microsoft.com/store/apps/9PK4Z59D5JDC",
        appleAppStoreUrl: "https://apps.apple.com/ch/app/fairwalter-abnahme/id6450003275"
    }
};

const storeBadges = [
    {
        key: "google",
        src: GooglePlayBadge,
        alt: "Google PlayStore Badge",
        urlKey: "googlePlayUrl" as const
    },
    {
        key: "microsoft",
        src: MicrosoftStoreBadge,
        alt: "Microsoft Store Badge",
        urlKey: "microsoftStoreUrl" as const
    },
    {
        key: "apple",
        src: AppStoreBadge,
        alt: "Apple App Store Badge",
        urlKey: "appleAppStoreUrl" as const
    }
];

export const InspectionAppHintBase = () => {
    const { uiStore, navStore, authStore } = useContext(RootStoreContext);
    const { t } = useTranslation();
    const erpType = authStore.user?.erpType;
    const currentErpConfig = (erpType && erpConfig[erpType]) || erpConfig[ErpType.RIMO];

    useEffect(() => {
        runInAction(() => {
            uiStore.setShowSearchAppbarButton(false);
            navStore.setTitle(t(currentErpConfig.titleKey));
            navStore.setBackbutton(null);
            navStore.setActionButtonMiddle(null);
            navStore.setActionButtonRight(null);
            navStore.setActionButtonLeft(null);
        });
        return () => {
            uiStore.setShowSearchAppbarButton(true);
        };
    });

    return (
        <UI.Container className="pt-4 mt-4">
            <UI.Row>
                <UI.Col xs={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }} xl={{ span: 6, offset: 3 }}>
                    <UI.Card>
                        <div className="mt-3">
                            <p>{t("screens.inspectionhint.hint")}</p>
                            <UI.Row className="mt-4">
                                {storeBadges.map((badge) => (
                                    <UI.Col key={badge.key} sm={4} className={styles.StoreBadgeItem}>
                                        <a href={currentErpConfig[badge.urlKey]} rel="noreferrer" target="_blank">
                                            <img src={badge.src} alt={badge.alt} />
                                        </a>
                                    </UI.Col>
                                ))}
                            </UI.Row>
                        </div>
                    </UI.Card>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};
export const InspectionAppHint = Sentry.withProfiler(withRouter(observer(InspectionAppHintBase)));
